<taku-input-autocomplete
  [isDropDown]="isDropDown"
  [formGroup]="formGroup"
  [_autocompleteOptions]="timeZoneAutoCompleteOptions"
  [fieldName]="fieldName"
  fieldCaption="Time Zone"
></taku-input-autocomplete>
